import FbButton from 'components/FbUI/FbButton'
import { FbLink } from 'components/FbUI/FbLink'
import {
  filterStoreRepo,
  useFilterParams,
} from 'components/Filters/FilterStore'
import { MobileSearchSelectView } from 'components/MobileSearchSelectView'
import { MobileModal } from 'components/UI/Modal/MobileModal'
import { DoorProxyForDealsSelection } from 'models/door_proxies_for_deals_selection'
import { useState } from 'react'
import { PiPlusCircleBold } from 'react-icons/pi'
import useApiService from 'services/api'

type Props = {
  title?: string
  onCancel: () => void
  onSubmit: (arg: number[]) => void
  chainProxyId: number
  initialDoorIds: number[]
}

export function MobileSelectLocationsModal({
  title = 'Edit A Deal',
  onCancel,
  onSubmit,
  chainProxyId,
  initialDoorIds = [],
}: Props) {
  const api = useApiService()

  const filterStore = filterStoreRepo.getStore('SELECT_LOCATIONS')
  const [doorIds, setDoorIds] = useState<number[]>(initialDoorIds)

  const PAGE_SIZE = 20
  const params = useFilterParams(filterStore)

  const infiniteQuery = api.useGetLocationsInfinite(chainProxyId, {
    ...params,
    page_size: PAGE_SIZE,
  })

  return (
    <MobileModal
      header={
        <div className="p-2">
          <div className="text-xs uppercase tracking-wide text-gray-500 mb-1">
            {title}
          </div>
          <h1 className="text-2xl font-semibold text-gray-900">
            Select Locations
          </h1>
        </div>
      }
      footer={
        <div>
          <div className="flex gap-4 p-2 justify-between">
            <div className="w-1/2">
              <FbButton
                className="w-full"
                type="button"
                size="mdlg"
                variant="secondary"
                onClick={onCancel}
              >
                Back
              </FbButton>
            </div>
            <div className="w-1/2">
              <FbButton
                className="w-full"
                type="button"
                size="mdlg"
                variant="primary"
                onClick={() => onSubmit(doorIds)}
              >
                <PiPlusCircleBold style={{ fontSize: 18 }} />
                Add Locations
              </FbButton>
            </div>
          </div>
        </div>
      }
    >
      <MobileSearchSelectView<
        { results: DoorProxyForDealsSelection[]; count: number },
        DoorProxyForDealsSelection
      >
        filterStoreIdentifier="SELECT_LOCATIONS"
        initialSelectedIds={initialDoorIds}
        infiniteQuery={infiniteQuery}
        onChange={(doorIds) => setDoorIds(doorIds.map((d) => Number(d.value)))}
        extractItems={(page) =>
          page.results.map((p) => ({ value: p.id, label: p.name, ...p }))
        }
        extractCount={(page) => page.count}
        renderItem={(item) => (
          <>
            <div>{item.label}</div>
            <FbLink style={{ fontSize: 10 }} to={item.place_url as string}>
              {item.address as string}
            </FbLink>
          </>
        )}
      />
    </MobileModal>
  )
}
